import createLucideIcon from '../createLucideIcon';

const ChevronUpSquare = createLucideIcon('ChevronUpSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '8,14 12,10 16,14', key: '1ksves' }],
]);

export default ChevronUpSquare;
